module.exports = __webpack_public_path__ + "img/tutorial_ten_en.d17e9b18.png";